import * as React from 'react';
import { connect } from 'react-redux';
import * as AOIModule from 'Modules/AOIModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { Popup } from 'react-leaflet';
import ManageablePolygon from './ManageablePolygon';
import AddAoiForm from 'components/Layout/Form/AddAoiForm';
import { createCoordsXYZ } from 'components/Map/CarDetails/Composites/_CompositesHelpers';

type ConnectedP = {
    aoiStore: AOIModule.Types.AOIStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

type DispatchedP = {
    deleteAoi: Function;
    hideAoiDetailsPopup: Function;
    setActiveAoi: Function;
    updateAoi: (updatedAoiDetails: AOIModule.Types.AddAreaOfInterestRequest, aoiId: number) => void;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => void;
};

type S = {
    positions: Array<Array<Array<L.LatLngExpression>>>;
    listVisible: boolean;
};

class AoiZones extends React.Component<ConnectedP & DispatchedP, S> {
    constructor(props: ConnectedP & DispatchedP) {
        super(props);
        this.state = {
            positions: [],
            listVisible: true
        };
        this.onDelete = this.onDelete.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    private onDelete() {
        const { deleteAoi, aoiStore, showPopup } = this.props;
        const { PopupType } = ViewManagementModule.VMEnumTypes;
        showPopup({
            type: PopupType.DELETE_AOI,
            confirmCallback: async () => {
                await deleteAoi(aoiStore.activeAoi.id);
                // hidePoiDetails();
            }
        });
    }
    private async handleSubmit(formData: any) {
        const { updateAoi, aoiStore } = this.props;
        const coords = createCoordsXYZ(this.state.positions[0][0]);
        const aoiDetails: AOIModule.Types.AddAreaOfInterestRequest = {
            title: formData.title,
            address: formData.address,
            coordinates: [coords]
        };
        await updateAoi(aoiDetails, aoiStore.activeAoi.id);
        this.setState({ listVisible: false }, () => this.setState({ listVisible: true }));
    }
    public render() {
        const { aoiStore, viewManagementStore, hideAoiDetailsPopup, setActiveAoi } = this.props;
        const { listVisible } = this.state;
        return (
            <>
                {aoiStore.aoiDetailsPopupVisible && !viewManagementStore.activeAddingAOI && (
                    <Popup
                        autoPan={false}
                        className="poidetails__wrapper"
                        position={{ lat: aoiStore.activeAoi.multipolygonGeoJson.coordinates[0][0][0][0], lng: aoiStore.activeAoi.multipolygonGeoJson.coordinates[0][0][0][1] }}
                    >
                        <AddAoiForm
                            initialValues={{ title: aoiStore.activeAoi.title, address: aoiStore.activeAoi.address }}
                            {...{
                                onClose: () => {
                                    hideAoiDetailsPopup();
                                    setActiveAoi(null);
                                },
                                onDelete: this.onDelete
                            }}
                            onSubmit={this.handleSubmit}
                        />
                    </Popup>
                )}
                {listVisible &&
                    aoiStore.aoiList.map((element, i) => (
                        <ManageablePolygon
                            key={`${element.id}-single_aoi_el`}
                            positions={element.multipolygonGeoJson.coordinates}
                            zoneData={element}
                            active={aoiStore.activeAoi ? element.id === aoiStore.activeAoi.id : false}
                            exportPositions={(positions: Array<Array<Array<L.LatLngExpression>>>) => this.setState({ positions })}
                        />
                    ))}
            </>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        aoiStore: state.aoiStore,
        viewManagementStore: state.viewManagementStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        deleteAoi: (aoiId: number) => dispatch(AOIModule.Actions.deleteAoi(aoiId)),
        updateAoi: (updatedAoiDetails: AOIModule.Types.AddAreaOfInterestRequest, aoiId: number) => dispatch(AOIModule.Actions.updateAoi(updatedAoiDetails, aoiId)),
        hideAoiDetailsPopup: () => dispatch(AOIModule.Actions.hideAoiDetailsPopup()),
        setActiveAoi: (aoiDetails: AOIModule.Types.AreaOfInterestDto) => dispatch(AOIModule.Actions.setDetailsForAoiView(aoiDetails)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData))
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(AoiZones);



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/AoiZones.tsx